import { FunctionComponent } from "react";
import styles from "./SteppersTrack.module.css";

export type SteppersTrackType = {
  className?: string;

  type?: "inactive" | "inprogress" | "hidden";
  direction?: "horizontal" | "vertical";
};

const SteppersTrackAtom: FunctionComponent<SteppersTrackType> = ({
  className = "",
  type = "inactive",
  direction = "horizontal",
}) => {
  return (
    <div
      className={[styles.root, className].join(" ")}
      data-type={type}
      data-direction={direction}
    ></div>
  );
};

export default SteppersTrackAtom;
